import { PerformanceAudienceFilterOption, PerformanceAudienceSummary } from '@/services/endpoints/performanceAudience';
import { SelectOption } from '@/lib/Selects/Select/types';
import { FC } from 'react';
import { PerformanceAudienceFilterCard } from '../PerformanceAudienceFilterCard';

type PerformanceAudienceFiltersProps = {
  isRefetching?: boolean;
  summary?: PerformanceAudienceSummary;
  audiences: PerformanceAudienceFilterOption[];
  googleScopes: PerformanceAudienceFilterOption[];
  metaScopes: PerformanceAudienceFilterOption[];
  dateRanges: PerformanceAudienceFilterOption[];
  selectedAudienceId: string;
  selectedGoogleScopeId: string;
  selectedMetaScopeId: string;
  selectedDateRangeId: string;
  onAudienceChange: (option: SelectOption) => void;
  onGoogleScopeChange: (option: SelectOption) => void;
  onMetaScopeChange: (option: SelectOption) => void;
  onDateRangeChange: (option: SelectOption) => void;
};

export const PerformanceAudienceFilters: FC<PerformanceAudienceFiltersProps> = (props) => {
  return <PerformanceAudienceFilterCard {...props} />;
};
